export const vracanje_osnove= {
    templateId: 71,
    category: 7,
    templateTitle: 'Ovrha - dostava rješenja o ovrsi novom poslodavcu',
    templateDescription: `<p>Kod prestanka radnog odnosa poslodavac je dužan na određeni način postupiti sa zaprimljenim rješenjem o ovrsi te je dužan dostaviti rješenje novom poslodavcu (ukoliko mu je poznat eventualni novi poslodavac radnika) ili poslati obavijest sudu da je radniku prestao radni odnos (ukoliko mu nije poznat novi poslodavac radnika).</p>`,
    description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Kod prestanka radnog odnosa radnika za kojega je zaprimio rješenja o ovrsi, poslodavac ima sljedeće obveze:</p>
    <li> ukoliko mu je poznat novi poslodavac - bez odgode preporučenom pošiljkom s povratnicom dostaviti rješenje o ovrsi novom poslodavcu prema dolje navedenom primjeru i o tome obavijestiti sud prema primjeru <a class="local-link" href="/contract?template=72.1">ovdje</a>,</p></li>
    <li> ukoliko mu nije poznat novi poslodavac - bez odgode obavijestiti sud o prestanku ugovora o radu prema primjeru <a class="local-link" href="/contract?template=72">ovdje</a>, a o čemu će sud obavijestiti ovrhovoditelja, određujući mu rok radi pribave podataka o novom poslodavcu.</li>
    <br>Poslodavac koji je propustio postupiti prema navedenim obvezama,  odgovara za štetu koju je ovrhovoditelj zbog toga pretrpio.</br>
    <p>Sličan je postupak kod postupanja s osnovama za plaćanje (privatne isprave s učinkom o rješenju o ovrsi) te je poslodavac dužan predati navedenu ispravu novom poslodavcu, ukoliko mu je poznat te o tome obavijestiti vjerovnika ili je dužan ispravu vratiti vjerovniku preporučenom pošiljkom uz povratnicu.</p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Povrat osnove za plaćanje radniku (dužniku), slanje osnove za plaćanje krivom adresatu/primatelju ili nepostupanje prema obvezama iz Ovršnog zakona</strong></p>
    <p>Pojašnjenje:  postoji opasnost za poslodavca da će odgovarati za štetu vjerovniku ukoliko ispravu preda trećemu (radniku ili bilo kojoj drugoj osobi) ili ne postupi kako je zakonom određeno. Iz navedenih razloga, uvijek je potrebno postupiti kako je gore navedeno.</p>
    
    <h5>PRAVNA OSNOVA</h5>
    <p>Ovršni zakon.</p>
  `,
  sides: [
    {
      prefix: "",
      signature: "",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Naziv primatelja",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto i poštanski broj",
      },
      {
        type: "input",
        required: false,
        placeholder: "Ostali podaci po potrebi",
      },
    ],
      suffix: "",
    }
  ],

  headline: "",
    title: '\r\n\r\nPREDMET: Dostava rješenja o ovrsi protiv radnika',
    noArticleNumbers: true,
    noArticleTitle: true,

    articles: [
        {
            title: '',
            mandatory: false,
            dummy: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: '- molim na ruke, ________________',
                    help: 'Po želji, slobodno upišite osobu kojoj želite dostaviti dopis.',
                    value: '',
                }],
        },
            
                {
                    title: '',
                    mandatory: true,
                    exampleContent: true,
                    dummy: true,
                    statements: [
                        {
                            type: 'text',
                            mandatory: true,
                            editable: true,
                            content: 'Poštovani,\r\n\r\novim putem Vas obavještavamo da smo za vašeg trenutnog radnika ______________, iz _________________, koji je bio prethodno naš zaposlenik, u posjedu rješenja o ovrsi koje nam je prethodno dostavljeno i po kojemu smo postupali u skladu s Ovršnim zakonom.\r\nOvim putem Vam u privitku dostavljamo spomenuto rješenje o ovrsi radi daljnjeg postupanja, a čime ispunjavamo našu obvezu iz čl. 200. Ovršnog zakona.  \r\n\r\nS poštovanjem.',
                            value: '',
                        }],
                },
                {
                    mandatory: true,
                    static: true,
                    type: 2, // date and place
                    statements: [
                      {
                        type: "input",
                        mandatory: true,
                        parts: [
                          {
                            type: "text",
                            content: "U"
                          },
                          {
                            type: "input",
                            value: "",
                            placeholder: "Upišite mjesto.",
                            required: true,
                          },
                          {
                            type: "text",
                            content: ", dana"
                          },
                          {
                            type: "date",
                            value: new Date(),
                            required: true
                          },
                          {
                            type: "text",
                            content: "godine."
                          }
                        ]
                      },
                    ]
                  },
                {
                    mandatory: true,
                    static: true,
                    type: 3,  // signatures
                    statements: [],
                },
                {
                    static: true,
                    mandatory: false,
                    type: 4, 
                    statements: [
                      {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Dostaviti:\r\n1) Ovrhovoditelju (vjerovniku) radnika \r\n2) Kadrovska služba\r\n\r\n Na znanje: \r\n1) Sudu',
                        help: 'Po želji, slobodno dopišite kome želite dostaviti dopis odnosno izmijenite/obrišite predložene unose.'
                      }
                    ]
                  },
            ],
};












// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/71_vracanje_osnove.ts